import React, {Component} from 'react'
import {connect} from 'react-redux'
import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableFooter from '@material-ui/core/TableFooter'
import Paper from '@material-ui/core/Paper'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import TextField from '@material-ui/core/TextField'
import Tooltip from '@material-ui/core/Tooltip'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import ClearIcon from '@material-ui/icons/Clear'
import ModeEditIcon from '@material-ui/icons/ModeEdit'
import MenuItem from '@material-ui/core/MenuItem';
import CopyToClipboard from 'react-copy-to-clipboard';
import _ from 'lodash'
import E from 'wangeditor'
import { reduxForm} from 'redux-form'
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Pagination from '../../../../../uis/pagination'
import NoData from '../../../../../uis/noData'
import * as actions from '../reducers/list'
import EnhancedFilterField from '../../../../../uis/enhancedFilterFiled';
import Text from '../../../../../uis/form/text';
import Select from '../../../../../uis/form/select'
import dateFormat from '../../../../../util/dateFormat'
import * as http from '../../../../../util/http'
import * as tip from '../../../../../uis/tip/reduces'

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto',
    },
    table: {
        minWidth: 700,
    },
    dialogContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    textField: {
        width: 300,
        margin: theme.spacing.unit
    },
    dislogActions: {
        display: 'flex',
        justifyContent: 'space-around',
        margin: theme.spacing.unit * 3
    },
    contentCell: {
        maxWidth: 100,
        whiteSpace: 'noWrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden'
    },
    group: {
        margin: `${theme.spacing.unit}px 0`,
        flexDirection: 'row'
    },
})

const validate = values => {
    const errors = {}
    
    if (!values.category) {
        errors.category = '必填'
    }

    if (!values.question) {
        errors.question = '必填'
    }
    
    if (!values.answer) {
        errors.answer = '必填'
    }
    
    return errors
}

class AddDialog extends React.Component {
    initWangeditor(inputElement, name, change) {
        if (!this[name]) {
            this[name] = new E(inputElement)
            // 配置服务器端地址
            this[name].customConfig.uploadImgServer = '/api/upload/img'
            this[name].customConfig.uploadFileName = 'files'
            this[name].customConfig.uploadImgMaxSize = 5 * 1024 * 1024;
            this[name].customConfig.uploadImgMaxLength = 5;
            this[name].customConfig.uploadImgHeaders = {
                'token': http.getUserInfo().token
            }
            // 使用 onchange 函数监听内容的变化，并实时更新到 state 中
            this[name].customConfig.onchange = html => {
                change(name, html);
            }
            this[name].create()
        }
    }
    render() {
        const {classes, dispatch, showModal, pristine, submitting, handleSubmit, change} = this.props
        return (<Dialog
            open={showModal.add}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            maxWidth="md"
            fullWidth
        >
            <form onSubmit={(handleSubmit)} noValidate autoComplete="off">
                <DialogContent className={classes.dialogContent}>
                    <Select name="category" label="分类" placeholder="请输入分类" className={classes.doubleTextField} style={{width: '100%'}} required={true} data={[{"name":"仿站售后","value":"仿站售后"},{"name":"仿站售前","value":"仿站售前"},{"name":"自建系统售后","value":"自建系统售后"},{"name":"自建系统售前","value":"自建系统售前"},{"name":"域名","value":"域名"},{"name":"服务器","value":"服务器"},{"name":"企业邮箱","value":"企业邮箱"},{"name":"其他","value":"其他"}]}/>

                    <Text name="question" label="问题" placeholder="请输入问题" className={classes.doubleTextField} style={{width: '100%'}} required={true} data={[]}/>
                    
                    <div className={classes.doubleTextField} style={{width: '100%'}} ref={el => this.initWangeditor(el, 'answer', change)}>
                    </div>
                    
                </DialogContent>
                <DialogActions className={classes.dislogActions}>
                    <Button variant="outlined" onClick={() => dispatch({type: actions.HIDE_MODAL})}>取消</Button>
                    <Button type="submit" variant="outlined" color="primary" disabled={pristine || submitting}>确定</Button>
                </DialogActions>
            </form>
        </Dialog>)
    }
}
class UpdateDialog extends Component {
    initWangeditor(inputElement, name, change) {
        const {initialValues} = this.props;
        if (!this[name]) {
            this[name] = new E(inputElement)
            // 配置服务器端地址
            this[name].customConfig.uploadImgServer = '/api/upload/img'
            this[name].customConfig.uploadFileName = 'files'
            this[name].customConfig.uploadImgMaxSize = 5 * 1024 * 1024;
            this[name].customConfig.uploadImgMaxLength = 5;
            this[name].customConfig.uploadImgHeaders = {
                'token': http.getUserInfo().token
            }
            // 使用 onchange 函数监听内容的变化，并实时更新到 state 中
            this[name].customConfig.onchange = html => {
                change(name, html);
            }
            this[name].create()
            this[name].txt.html(initialValues[name])
        }
    }
    render() {
        const {classes, dispatch, showModal, pristine, submitting, handleSubmit, change} = this.props
        return (<Dialog
            open={showModal.update}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            maxWidth="md"
            fullWidth
        >
            <form onSubmit={(handleSubmit)} noValidate autoComplete="off">
                <DialogContent className={classes.dialogContent}>
                    <Select name="category" label="分类" placeholder="请输入分类" className={classes.doubleTextField} style={{width: '100%'}} required={true} data={[{"name":"仿站售后","value":"仿站售后"},{"name":"仿站售前","value":"仿站售前"},{"name":"自建系统售后","value":"自建系统售后"},{"name":"自建系统售前","value":"自建系统售前"},{"name":"域名","value":"域名"},{"name":"服务器","value":"服务器"},{"name":"企业邮箱","value":"企业邮箱"},{"name":"其他","value":"其他"}]}/>

                    <Text name="question" label="问题" placeholder="请输入问题" className={classes.doubleTextField} style={{width: '100%'}} required={true} />
                    
                    <div className={classes.doubleTextField} style={{width: '100%'}} ref={el => this.initWangeditor(el, 'answer', change)}>
                    </div>
                    
                </DialogContent>
                <DialogActions className={classes.dislogActions}>
                    <Button variant="outlined" onClick={() => dispatch({type: actions.HIDE_MODAL})}>取消</Button>
                    <Button type="submit" variant="outlined" color="primary" disabled={pristine || submitting}>确定</Button>
                </DialogActions>
            </form>
        </Dialog>)
    }
}

class DeleteDialog extends Component {
    render() {
        const {dispatch,showModal} = this.props
        return (<Dialog
            open={showModal.delete}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            fullWidth
        >
            <DialogContent>确定删除吗？</DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={() => dispatch({type: actions.HIDE_MODAL})}>取消</Button>
                <Button variant="outlined" color="primary" onClick={() => dispatch(actions.remove(showModal.id))}>确定</Button>
            </DialogActions>
        </Dialog>)
    }
}

const AddFormDialog = reduxForm({
    form: 'questionAnswerAddForm',
    validate
})(AddDialog)

const UpdateFormDialog = connect(
    state => ({
      initialValues: state.questionAnswer.detail
    }),
  )(reduxForm({
    form: 'questionAnswerUpdateForm'
})(UpdateDialog))

class Questionanswer extends Component {
    componentDidMount() {
        const {dispatch}  = this.props
        dispatch(actions.getList())
    }
    onPageClick = (index) => {
        const {dispatch,page} = this.props
        dispatch({
            type: actions.CHANGE_PAGE,
            page: {...page, index}
        })
        dispatch(actions.getList())
    }
    handleFiltersClick = (value) => {
        const { dispatch,filterList } = this.props
        const valueItem = filterList.find(item=>item.value === value);
        valueItem.isShow = !valueItem.isShow;
        dispatch({type: actions.CHANGE_FILTER_LIST,value: _.clone(filterList)})
    }
    cancelFiltersClick = (value) => {
        const { dispatch, query } = this.props
        this.handleFiltersClick(value);
        if (query[value]) {
            dispatch({type: actions.CHANGE_QUERY, key: value, value: null})
            dispatch(actions.getList())
        }
    }
    changeQuery = (e,name) => {
        const {dispatch} = this.props;
        dispatch({type: actions.CHANGE_QUERY,key: name,value: e.target.value})
        dispatch(actions.getList())
    }
    render() {
        const {classes, dispatch, list, page, total ,permissionMap, query, filterList, showModal} = this.props;
        return (
            <div>
                <Grid container spacing={8} alignItems="baseline" style={{justifyContent: 'space-between'}}>
                    <Grid item>
                        {permissionMap['问答库_新增'] && <Button variant="outlined" color="secondary" onClick={() => dispatch({type: actions.SHOW_MODAL,key: 'add'})}>新增</Button>}
                    </Grid>
                    <Grid item>
                        <TextField
                            select
                            label="选择筛选条件"
                            margin="normal"
                            style={{minWidth: 200}}
                            onChange={(event) => this.handleFiltersClick(event.target.value)}
                        >
                            {filterList.filter(item => !item.isShow).map((item, index) => {
                                return (
                                    <MenuItem
                                        key={index}
                                        value={item.value}
                                    >
                                        {item.name}
                                    </MenuItem>
                                );
                            })}
                        </TextField>
                    </Grid>
                </Grid>
                <Grid container spacing={8}>
                    <FormControl component="fieldset" className={classes.formControl}>
                        <RadioGroup
                            name="category"
                            className={classes.group}
                            value={query.category}
                            onChange={(e) => this.changeQuery(e,'category')}
                        >
                            <FormControlLabel value="" control={<Radio checked={!query.category} />} label={<p>全部<span style={{color: 'red'}}></span></p>} />
                            <FormControlLabel value="仿站售后" control={<Radio />} label={<p>仿站售后<span style={{color: 'red'}}></span></p>} />
                            <FormControlLabel value="仿站售前" control={<Radio />} label={<p>仿站售前<span style={{color: 'red'}}></span></p>} />
                            <FormControlLabel value="自建系统售后" control={<Radio />} label={<p>自建系统售后<span style={{color: 'red'}}></span></p>} />
                            <FormControlLabel value="自建系统售前" control={<Radio />} label={<p>自建系统售前<span style={{color: 'red'}}></span></p>} />
                            <FormControlLabel value="域名" control={<Radio />} label={<p>域名<span style={{color: 'red'}}></span></p>} />
                            <FormControlLabel value="服务器" control={<Radio />} label={<p>服务器<span style={{color: 'red'}}></span></p>} />
                            <FormControlLabel value="企业邮箱" control={<Radio />} label={<p>企业邮箱<span style={{color: 'red'}}></span></p>} />
                            <FormControlLabel value="其他" control={<Radio />} label={<p>其他<span style={{color: 'red'}}></span></p>} />
                        </RadioGroup>
                    </FormControl>
                </Grid>
                <Grid container spacing={8}>
                    {filterList.filter(item => item.isShow).map((item, index) => {
                        return (
                            <EnhancedFilterField
                                item={item}
                                value={query[item.value]}
                                key={index}
                                onHandleQuery={(e) => this.changeQuery(e, item.value)}
                                onCancel={this.cancelFiltersClick}
                            />
                        );
                    })}
                </Grid>
                <Paper className={classes.root}>
                    {list.length === 0 && <NoData />}
                    {list.length > 0 && <Table className={classes.table}>
                        <TableHead>
                            <TableRow>
                                <TableCell>分类</TableCell>

                                <TableCell style={{maxWidth: 200}}>问题</TableCell>
                                
                                <TableCell style={{maxWidth: 400}}>回答</TableCell>

                                <TableCell>创建时间</TableCell>
                                
                                {(permissionMap['问答库_修改'] || permissionMap['问答库_删除']) && <TableCell>操作</TableCell>}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {list.map(row => {
                                const tmp = document.createElement("DIV");
                                tmp.innerHTML = row.answer;
                                return (
                                    <TableRow key={row.id}>
                                        <TableCell>{row.category}</TableCell>
                                        
                                        <TableCell style={{maxWidth: 200, wordBreak: 'break-all'}}>{row.question}</TableCell>
                                        
                                        <TableCell style={{maxWidth: 400, wordBreak: 'break-all'}} dangerouslySetInnerHTML={{__html: row.answer}}></TableCell>

                                        <TableCell>
                                            {dateFormat(new Date(row.createTime))}<br/><br/>
                                            <CopyToClipboard text={tmp.textContent || tmp.innerText || ""}  onCopy={() => dispatch(tip.success('复制成功'))}>
                                                        <a href={`javascript:;`}>一键复制答案</a>
                                            </CopyToClipboard>
                                        </TableCell>
                                        
                                        {(permissionMap['问答库_修改'] || permissionMap['问答库_删除']) && <TableCell>
                                            
                                            {permissionMap['问答库_修改'] && <Tooltip title="修改">
                                                <IconButton color="primary" onClick={()=>dispatch(actions.showUpdateModal(row.id))}><ModeEditIcon /></IconButton>
                                            </Tooltip>}
                                            {permissionMap['问答库_删除'] && <Tooltip title="删除">
                                                <IconButton color="secondary" onClick={() => dispatch({type: actions.SHOW_MODAL,key: 'delete', id: row.id})}><ClearIcon /></IconButton>
                                            </Tooltip>}
                                        </TableCell>}
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                        <TableFooter>
                            <Pagination 
                                total={total}
                                {...page}
                                onPageClick={this.onPageClick}
                            />
                        </TableFooter>
                    </Table>}
                </Paper>
                {showModal.add && <AddFormDialog {...this.props} onSubmit={(formData)=>dispatch(actions.add(formData))}/>}
                {showModal.update && <UpdateFormDialog {...this.props} onSubmit={(formData)=>dispatch(actions.update(formData))} />}
                {showModal.delete && <DeleteDialog {...this.props} />}
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state.questionAnswer,
        permissionMap: state.auth.user.permissionMap
    }
}

export default connect(mapStateToProps)(withStyles(styles)(Questionanswer))


// WEBPACK FOOTER //
// ./src/pages/home/routes/question_answer/components/list.js